<template>
  <td class="table-v2__body-cell" :style="cellStyle">
    <slot />
  </td>
</template>

<script>
export default {
  name: 'TableCellV2',
  props: {
    align: {
      type: String,
      default: 'left',
    },
    width: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    cellStyle() {
      const style = {};
      if (this.width) {
        style.width =
          typeof this.width === 'number' ? `${this.width}px` : this.width;
      }
      if (this.align) {
        style.textAlign = this.align;
      }
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
.table-v2__body-cell {
  padding: 8px 12px;
  height: 52px;
  color: #717171;
  font-size: 14px;
  line-height: 24px;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
